import { useEffect, useMemo, type ReactNode } from 'react'
import { FluentProvider } from '@fluentui/react-components'
import { useOverrides } from '../styleguide/react'
import { cssVarsFor, lookAndFeel, themeFor } from '../lib/lookAndFeel'

/**
 * The app's FluentProvider, wearing whatever the admin Look & feel drawer has
 * applied in this tab. With nothing applied — every visit but an admin's
 * tuning session — the theme is bayerLightTheme and no variable is set.
 */
export function LookAndFeelProvider({ children }: { children: ReactNode }) {
  const overrides = useOverrides(lookAndFeel)
  const theme = useMemo(() => themeFor(overrides), [overrides])

  useEffect(() => {
    const vars = cssVarsFor(overrides)
    const style = document.documentElement.style
    Object.entries(vars).forEach(([name, value]) => style.setProperty(name, value))
    return () => Object.keys(vars).forEach((name) => style.removeProperty(name))
  }, [overrides])

  return <FluentProvider theme={theme}>{children}</FluentProvider>
}
